import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {getStrategyResultsRequest} from 'requests';
import Prediction from './components/Prediction';
import Tags from './components/Tags';
import Price from './components/Price';
import {Arrow} from './icons';
import './strategy.scss';

class Strategy extends Component {
  state = {
    results: {},
    loading: true,
  };

  async componentDidMount() {
    try {
      const results = await getStrategyResultsRequest(this.props.strategyId);
      this.setState({results, loading: false});
    } catch (err) {
      console.warn(err);
    }
  }

  render() {
    const {strategy, strategyId} = this.props;
    const {results, loading} = this.state;

    if (loading) return null;

    return (
      <div className="strategy">
        {strategy.tags && strategy.tags.length > 0 && <Tags data={strategy.tags} />}
        <Prediction results={results} strategy={strategy} />
        <div className="footer">
          <Price price={strategy.price} moneyBack={strategy.moneyBack} />
          <Link to={{pathname: `/s/${strategyId}`, state: {strategy}}} className="strategy-details-link">
            <Arrow />
          </Link>
        </div>
      </div>
    );
  }
}

export default Strategy;
